export default "__VITE_ASSET__BL7FOOK4__"